const key = "force-match-entities";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const modify = (resp) => {
	if(!resp.data.Data?.Fields) {
		return;
	}
	
	const entityFields = resp.data.Data.Fields.filter(f => f.Type.Code === "ENTITY");

	// entityFields.forEach(f => f.matchSpecificity = true);

	const dealerField = entityFields.find(f => f.Key.Code === "REPORT.ENTITIES.DEALERS.LICENSES.SINGLE");
	dealerField.Data[0].IsFavorite = true;
	// dealerField.Data[1].IsFavorite = true;
};

export const forceMatchEntities = [key, applicable, modify];